export const env = {
  // @ts-ignore
  isSSR: () => typeof window === 'undefined',
};
